import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatPaymentFrequencyModel } from 'src/app/model/cat-payment-frecuency.model';
import { CatPaymentFrequencyService } from 'src/oldApp/services/cat-payment-frequency.service';

@Component({
  selector: 'app-modal-payment-frequency',
  templateUrl: './modal-payment-frequency.component.html',
  styleUrls: ['./modal-payment-frequency.component.css']
})
export class ModalPaymentFrequencyComponent implements OnInit {
  @Input() frequency:CatPaymentFrequencyModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus=1;

  // marcaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                               // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},        // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  ////////////////
  constructor(
    private paymentFrequencyService:CatPaymentFrequencyService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive=()=> this.frequency.activeId=!this.frequency.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.frequency.description=this.frequency.description.toUpperCase();
      this.paymentFrequencyService.save(this.frequency)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll();
            this.toastr.success('La frecuencia se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la frecuencia.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  descriptionError=()=> !this.frequency.description || this.frequency.description.trim()==='';
}
